import WrongPortal from "@surgia/ui/containers/wrongPortal";
import { toast } from "sonner";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
function WrongPortalPage() {
  const { t } = useTranslation();
  const auth = useAuth();
  // const handleRedirect = () => {
  //   window.location.href = `${import.meta.env.VITE_WRONG_PORTAL}/login`;
  // };

  useEffect(() => {
    toast.error(t("shared.wrongPortal.accessDeniedToast"), {
      duration: 6000,
      description: t("shared.wrongPortal.accessDeniedDescription"),
    });
    auth.signoutSilent();
  }, []);

  return (
    <WrongPortal
      title={t("shared.wrongPortal.title")}
      // buttonText={t("shared.wrongPortal.goToAdmin")}
      // onClick={handleRedirect}
    >
      {t("shared.wrongPortal.description")}
      <br />
      {t("shared.wrongPortal.contactAdmin")}
    </WrongPortal>
  );
}

export default WrongPortalPage;
